import _ from 'lodash';

import {
  createFetchActionForNamespace,
  createPostActionForNamespace,
  createReducer,
  createFetchReducers,
  createPostReducers,
  createFetchSelectors,
  createFetchReducersWithPagination,
  createFetchPaginatedActionForNamespace
} from 'utils/reducers';

import {selectFilters, FILTERS} from 'ducks/filters';
import {transformFiltersForStoreToFiltersForApi} from 'utils/filters';

import {selectPagination, PAGINATION} from 'ducks/pagination';
import {transformPaginationForStoreToPaginationForApi} from 'utils/pagination';

const createFetchAction = createFetchActionForNamespace('notes');
const createPostAction = createPostActionForNamespace('notes');

const createFetchActionWithPagination = createFetchPaginatedActionForNamespace(
  'notes'
);

export const BOOKING_TYPE = 'Booking';
export const ROOM_TYPE = 'Room';
export const SALES_TYPE = 'Sales';

export const TOGGLE_ADD_BOOKING_NOTE_FORM =
  'notes/TOGGLE_ADD_BOOKING_NOTE_FORM';
export const SET_BOOKING_NOTE_FOR_EDIT = 'notes/SET_BOOKING_NOTE_FOR_EDIT';
export const SET_ROOM_NOTE_FOR_EDIT = 'notes/SET_ROOM_NOTE_FOR_EDIT';

export const addBookingNote = createPostAction({
  name: 'ADD_BOOKING_NOTE',
  initialAction: ({text, requiresAction, bookingId}, extraActions = []) => ({
    payload: {text, requiresAction, bookingId, extraActions}
  }),
  stateKey: 'bookingNotes.create',
  defaultStateValue: null,
  formName: 'addBookingNote'
});

export const resolveBookingNote = createPostAction({
  name: 'RESOLVE_BOOKING_NOTE',
  initialAction: ({noteId}, extraActions = []) => ({
    payload: {noteId, extraActions}
  })
});

export const fetchBookingNotes = createFetchAction({
  name: 'FETCH_BOOKING_NOTES',
  initialAction: ({bookingId, archived}, extraActions = []) => ({
    payload: {
      bookingId,
      archived,
      extraActions
    }
  }),
  stateKey: 'bookingNotes.notes',
  defaultStateValue: []
});

export const selectBookingNotesData = createFetchSelectors(fetchBookingNotes)
  .data;

export const selectBookingNotes = state => {
  const bookingNotesData = selectBookingNotesData(state);

  return _.get(bookingNotesData, 'notes', []);
};

export const TOGGLE_ADD_ROOM_NOTE_FORM = 'notes/TOGGLE_ADD_ROOM_NOTE_FORM';
// TODO: Move this information in room note modal
export const toggleAddRoomNoteForm = ({isOpened}) => ({
  type: TOGGLE_ADD_ROOM_NOTE_FORM,
  payload: {isOpened}
});
export const selectIsAddRoomNoteFormOpened = state =>
  _.get(state, 'notes.roomNotes.isAddNoteFormOpened', false);

export const toggleAddBookingNoteForm = ({isOpened}) => ({
  type: TOGGLE_ADD_BOOKING_NOTE_FORM,
  payload: {
    isOpened
  }
});
export const selectIsAddBookingNoteFormOpened = state =>
  _.get(state, 'notes.bookingNotes.isAddNoteFormOpened', false);

export const archiveBookingNote = createPostAction({
  name: 'ARCHIVE_BOOKING_NOTE',
  initialAction: ({note}, extraActions = []) => ({
    payload: {note, extraActions}
  })
});

export const restoreBookingNote = createPostAction({
  name: 'RESTORE_BOOKING_NOTE',
  initialAction: ({note}, extraActions = []) => ({
    payload: {note, extraActions}
  })
});

export const setBookingNoteForEdit = ({noteId}) => ({
  type: SET_BOOKING_NOTE_FOR_EDIT,
  payload: {
    noteId
  }
});

export const setRoomNoteForEdit = ({noteId}) => ({
  type: SET_ROOM_NOTE_FOR_EDIT,
  payload: {
    noteId
  }
});

export const editBookingNote = createPostAction({
  name: 'EDIT_BOOKING_NOTE',
  initialAction: ({note, text, requiresAction}, extraActions = []) => ({
    payload: {note, text, requiresAction, extraActions}
  }),
  formName: 'editBookingNote'
});

export const selectBookingNoteForEdit = state =>
  _.get(state, 'notes.bookingNotes.editNote');

export const fetchOtherBookingNotes = createFetchAction({
  name: 'FETCH_OTHER_BOOKINGS_NOTES',
  initialAction: ({bookingId, archived}, extraActions = []) => ({
    payload: {
      bookingId,
      archived,
      extraActions
    }
  }),
  stateKey: 'bookingNotes.otherBookingNotes',
  defaultStateValue: []
});

export const selectOtherBookingNotes = createFetchSelectors(
  fetchOtherBookingNotes
).data;

export const fetchRoomNotes = createFetchAction({
  name: 'FETCH_ROOM_NOTES',
  initialAction: ({roomId, archived}, extraActions = []) => ({
    payload: {roomId, archived, extraActions}
  }),
  stateKey: 'roomNotes.notes',
  defaultStateValue: []
});
const roomNotesSelector = createFetchSelectors(fetchRoomNotes);
export const selectRoomNotes = roomNotesSelector.data;
export const selectRoomNotesErrors = roomNotesSelector.errors;

export const addRoomNote = createPostAction({
  name: 'ADD_ROOM_NOTE',
  initialAction: ({text, roomId}, extraActions = []) => ({
    payload: {text, roomId, extraActions}
  }),
  formName: 'addRoomNote'
});

export const editRoomNote = createPostAction({
  name: 'EDIT_ROOM_NOTE',
  initialAction: ({note, text, roomId}, extraActions = []) => ({
    payload: {note, text, roomId, extraActions}
  }),
  formName: 'editRoomNote'
});

export const selectRoomNoteForEdit = state =>
  _.get(state, 'notes.roomNotes.editNote');

export const archiveRoomNote = createPostAction({
  name: 'ARCHIVE_ROOM_NOTE',
  initialAction: ({note}, extraActions = []) => ({
    payload: {note, extraActions}
  })
});

export const restoreRoomNote = createPostAction({
  name: 'RESTORE_ROOM_NOTE',
  initialAction: ({note}, extraActions = []) => ({
    payload: {note, extraActions}
  })
});

export const fetchSalesNotes = createFetchAction({
  name: 'FETCH_SALES_NOTES',
  initialAction: ({room, archived}, extraActions = []) => ({
    payload: {room, archived, extraActions}
  }),
  defaultStateValue: []
});

export const addSalesNote = createPostAction({
  name: 'ADD_SALES_NOTE',
  initialAction: ({text, requiresAction, room}, extraActions = []) => ({
    payload: {text, requiresAction, room, extraActions}
  }),
  formName: 'addSalesNote'
});

export const archiveSalesNote = createPostAction({
  name: 'ARCHIVE_SALES_NOTE',
  initialAction: ({note}, extraActions = []) => ({
    payload: {note, extraActions}
  })
});

export const restoreSalesNote = createPostAction({
  name: 'RESTORE_SALES_NOTE',
  initialAction: ({note}, extraActions = []) => ({
    payload: {note, extraActions}
  })
});

export const resolveSalesNote = createPostAction({
  name: 'RESOLVE_SALES_NOTE',
  initialAction: ({note}, extraActions = []) => ({
    payload: {note, extraActions}
  })
});

export const editSalesNote = createPostAction({
  name: 'EDIT_SALES_NOTE',
  initialAction: ({note, text}, extraActions = []) => ({
    payload: {note, text, extraActions}
  }),
  formName: 'editSalesNote'
});

export const fetchNotes = createFetchActionWithPagination({
  name: 'FETCH_NOTES',
  initialAction: ({locationRef}, extraActions = []) => ({
    payload: {locationRef, extraActions}
  }),
  stateKey: 'list',
  defaultStateValue: [],
  extraGetParamsSelectors: [
    state =>
      transformFiltersForStoreToFiltersForApi(
        selectFilters(state, FILTERS.NOTES_LIST)
      ),
    state =>
      transformPaginationForStoreToPaginationForApi(
        selectPagination(state, PAGINATION.NOTES_LIST)
      )
  ],
  paginationNamespace: PAGINATION.NOTES_LIST
});

const fetchNotesSelector = createFetchSelectors(fetchNotes);
export const selectNotes = fetchNotesSelector.data;
export const selectNotesLoading = fetchNotesSelector.isLoading;

const initialState: any = {};

const baseReducers = createReducer(initialState, {
  ...createFetchReducers(fetchBookingNotes),
  ...createFetchReducers(fetchOtherBookingNotes),
  ...createFetchReducers(fetchRoomNotes),

  ...createPostReducers(addBookingNote),

  ...createFetchReducersWithPagination(fetchNotes)
});

const reducer = (state = initialState, action) => {
  const newState = baseReducers(state, action);

  switch (action.type) {
    case TOGGLE_ADD_BOOKING_NOTE_FORM: {
      const {isOpened} = action.payload;
      return {
        ...state,
        bookingNotes: {
          ...state.bookingNotes,
          isAddNoteFormOpened: isOpened
        }
      };
    }
    case TOGGLE_ADD_ROOM_NOTE_FORM: {
      const {isOpened} = action.payload;
      return {
        ...state,
        roomNotes: {
          ...state.roomNotes,
          isAddNoteFormOpened: isOpened
        }
      };
    }

    case SET_BOOKING_NOTE_FOR_EDIT:
      return {
        ...state,
        bookingNotes: {
          ...state.bookingNotes,
          editNote: action.payload.noteId
        }
      };
    case SET_ROOM_NOTE_FOR_EDIT: {
      return {
        ...state,
        roomNotes: {
          ...state.roomNotes,
          editNote: action.payload.noteId
        }
      };
    }

    default:
      return newState;
  }
};

export default reducer;

export {default as notesSaga} from './saga';
